import { AuthLocaleTypes } from '../locales.types'

const authLocaleBo: AuthLocaleTypes = {
  login: 'Logg inn i Lærerportalen',
  logout: 'Logg ut',
  signup: 'Registrer deg',
  signout: 'Logg ut',
  withFeide: 'Logg inn med Feide',
  email: 'E-post',
  emailPlaceholder: 'døme@email.com',
  password: 'Passord'
}

export default authLocaleBo
